export class Legal {
  constructor() {
    this.id = "";
    this.name = "";
    this.idnumber = "";
    this.entityType = "";
    this.registration = "";
    this.hQName = "";
    this.hqName_text = "";
    this.industry = "";
    this.industryName = "";
    this.industries = "";
    this.industryNames = "";
    this.telephone = "";
  }
}
